
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/warehouseTransfer/new",
      function () {
        return require("private-next-pages/warehouseTransfer/new.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/warehouseTransfer/new"])
      });
    }
  